import React, { Component } from "react";
import { observer } from "mobx-react";
import { Button, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";
import Immersive3dTour from "~/models/Immersive3dTour/Immersive3dTour";

@observer
class AddOrRemoveTourModal extends Component {
  render() {
    const { visible, hideModal, addToTour, removeFromTour, immersive3dTour } = this.props;

    let modalHeader = "Mark this Immersive 3D Tour as ready?";
    let modalDescription = "This will add the Immersive 3D Tour to your tour.";
    let modalButtonLabel = "Add to Tour";

    if (immersive3dTour.isReady) {
      modalHeader = "Mark this Immersive 3D Tour as not ready?";
      modalDescription = "This will remove the Immersive 3D Tour to your tour.";
      modalButtonLabel = "Remove from Tour";
    }

    return (
      <Modal
        open={visible}
        onClose={() => {
          hideModal();
        }}
      >
        <Modal.Header>{modalHeader}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>{modalDescription}</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            secondary
            onClick={() => {
              hideModal();
            }}
          >
            Close
          </Button>
          <Button
            primary
            onClick={() => {
              hideModal();
              if (!immersive3dTour.isReady) {
                addToTour();
              } else {
                removeFromTour();
              }
            }}
          >
            {modalButtonLabel}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

AddOrRemoveTourModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  addToTour: PropTypes.func.isRequired,
  removeFromTour: PropTypes.func.isRequired,
  immersive3dTour: PropTypes.instanceOf(Immersive3dTour),
};

export default AddOrRemoveTourModal;
